import { JobType } from '@kcftech/prometheus-client';
import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import {
    RunningThresholdJob,
    toRunningThresholdJobs,
} from 'custom_hooks/data_hooks/jobs/runningAlertThresholdJobs.shared';
import { Filter } from 'utils/query_v3';

export function useRunningAlertThresholdJobs(locationId: string, enabled = true) {
    const { data: runningThresholdJobs, isError: runningThresholdJobsError } = useQuery({
        queryKey: ['running-alert-threshold-jobs', locationId],
        queryFn: async (): Promise<RunningThresholdJob[]> => {
            const filter = Filter.and(
                Filter.in('Type', [JobType.AlertThresholdGeneration]),
            );
            const jobs = await sdClient.getJobsByLocation({
                locationId,
                filter,
                page: 1,
                pageLimit: 100,
                orderBy: 'EnqueuedTime desc',
            });

            return toRunningThresholdJobs(jobs.Result);
        },
        enabled,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });

    return { runningThresholdJobs, runningThresholdJobsError };
}
